import {
  LOCAL_STORAGE_PREFIX,
  validateKey,
} from 'app/models/localStorage/constants';
import * as storageSelectors from 'app/models/storage/selectors';
import { createMockableFunction } from 'app/utils/mock';

const getLocalStorageState = state => state.get(LOCAL_STORAGE_PREFIX);

export const wasLocalStorageInitiallyAvailable =
  storageSelectors.wasStorageInitiallyAvailable(getLocalStorageState);

/**
 * @deprecated Use StorageContext instead
 */
export const getItem = createMockableFunction(
  storageSelectors.getItem(validateKey, getLocalStorageState),
);

/**
 * @deprecated Use StorageContext instead
 */
export const hasItem = storageSelectors.hasItem(validateKey, getLocalStorageState);
